<section
    [id]="id()"
    class="relative w-full h-full px-2"
    [attr.data-testid]="currentTestId()"
    [attr.data-styletarget]="id()"
>
    <section
        [attr.data-testid]="id() + '-graph'"
        [attr.data-styletarget]="id() + '-graph'"
        [attr.data-uitype]="'graph'"
        class="w-full h-full"
        #graph
    ></section>
</section>
<div [attr.data-json-info]="'region-rate-flatbed'" class="hidden">
    {{ data() | json }}
</div>
<meta name="description" [content]="data() | json" />